import { useEffect, useRef } from 'react';
import gsap from 'gsap';

interface Stage { id: string; title: string; text: string; detail: string; image: string }

interface Props {
  stages: Stage[];
  active: number;
  onSelect: (i: number) => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function ProcessStage({ stages, active, onSelect: _onSelect }: Props) {
  const textRef = useRef<HTMLDivElement>(null);
  const stage = stages[active];
  const total = stages.length;

  useEffect(() => {
    const el = textRef.current;
    if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    gsap.fromTo(el.children, { y: 10, opacity: 0 }, { y: 0, opacity: 1, duration: 0.4, stagger: 0.05, ease: 'power2.out', overwrite: true });
  }, [active]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 bg-[#16181D] border border-[#393D45] lg:h-[400px] xl:h-[440px]">
      <div className="lg:col-span-5 p-6 md:p-10 flex flex-col min-h-[280px]">
        <span className="font-heading text-sm tracking-[0.25em] text-[#D42B38]">
          STAGE 0{active + 1} <span className="text-[#777D87]">/ 0{total}</span>
        </span>
        <div ref={textRef} className="mt-5">
          <h3 className="font-heading uppercase text-[30px] md:text-[38px] leading-[0.95] text-[#F5F5F6]">{stage.title}</h3>
          <p className="mt-4 text-[15px] leading-relaxed text-[#F5F5F6]/75 max-w-[440px]">{stage.text}</p>
        </div>
        <div className="mt-auto pt-6 flex items-end justify-between gap-4 border-t border-[#393D45]">
          <p className="text-sm text-[#777D87] flex items-center gap-2">
            <span className="w-[6px] h-[6px] bg-[#EF616B] shrink-0" />{stage.detail}
          </p>
        </div>
      </div>
      <div className="lg:col-span-7 relative h-[240px] sm:h-[340px] lg:h-full overflow-hidden process-diag">
        {stages.map((s, i) => (
          <img
            key={s.id}
            src={s.image}
            alt={s.title}
            title={`${s.title} — Redline Garage repair process`}
            aria-hidden={i !== active}
            className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-500 ${i === active ? 'opacity-100' : 'opacity-0'}`}
          />
        ))}
      </div>
    </div>
  );
}